var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.25L4.92285 17.2461C4.54488 17.2075 4.25 16.8882 4.25 16.5C4.25 16.1118 4.54488 15.7925 4.92285 15.7539L5 15.75L21 15.75C21.4142 15.75 21.75 16.0858 21.75 16.5C21.75 16.9142 21.4142 17.25 21 17.25L5 17.25Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.75L7.92285 9.75391C7.54488 9.79253 7.25 10.1118 7.25 10.5C7.25 10.8882 7.54488 11.2075 7.92285 11.2461L8 11.25H23C23.4142 11.25 23.75 10.9142 23.75 10.5C23.75 10.0858 23.4142 9.75 23 9.75H8Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.25L0.922852 14.2461C0.544882 14.2075 0.25 13.8882 0.25 13.5C0.25 13.1118 0.544882 12.7925 0.922852 12.7539L1 12.75L19 12.75C19.4142 12.75 19.75 13.0858 19.75 13.5C19.75 13.9142 19.4142 14.25 19 14.25L1 14.25Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.25L2.92285 8.24609C2.54488 8.20747 2.25 7.88817 2.25 7.5C2.25 7.11183 2.54488 6.79253 2.92285 6.7539L3 6.75L17 6.75C17.4142 6.75 17.75 7.08579 17.75 7.5C17.75 7.91421 17.4142 8.25 17 8.25L3 8.25Z",
    fill: "#263238"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.75L17.5771 18.7539C17.9551 18.7925 18.25 19.1118 18.25 19.5C18.25 19.8882 17.9551 20.2075 17.5771 20.2461L17.5 20.25H7.5C7.08579 20.25 6.75 19.9142 6.75 19.5C6.75 19.0858 7.08579 18.75 7.5 18.75H17.5Z",
    fill: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.75L16.0771 3.75391C16.4551 3.79253 16.75 4.11183 16.75 4.5C16.75 4.88817 16.4551 5.20747 16.0771 5.24609L16 5.25H9C8.58579 5.25 8.25 4.91421 8.25 4.5C8.25 4.08579 8.58579 3.75 9 3.75H16Z",
    fill: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/Mist.a2197ececf841fdc9c98188ea1a85a04.svg";
export { ForwardRef as ReactComponent };